import { FC, useState } from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import { ID } from 'domain/types/ID';
import { useTranslationPrefix } from 'infrastructure/translations/i18n';

import { Container, ServiceDetailsField } from './common';
import { EditServiceNotesDialog } from './EditServiceNotesDialog';

export interface NotesServiceDetailsPreviewData {
  notes?: string;
  serviceId?: ID;
  canEdit?: boolean;
}

export interface NotesServiceDetailsPreviewProps {
  data: NotesServiceDetailsPreviewData;
}

export const NotesServiceDetailsPreview: FC<NotesServiceDetailsPreviewProps> = ({ data }) => {
  const t = useTranslationPrefix('jobs.service_details.notes');
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);

  return (
    <Container width={1} gap={4}>
      <Stack direction="row" alignItems="center" gap={2}>
        <Typography variant="h6">{t('title')}</Typography>
        {data.canEdit && data.serviceId && (
          <IconButton size="small" onClick={() => setIsEditDialogOpen(true)}>
            <EditIcon fontSize="small" />
          </IconButton>
        )}
      </Stack>
      <Stack gap={4}>
        <ServiceDetailsField
          title={t('notes_label')}
          value={data.notes ?? t('no_notes')}
          disabled={!data.notes}
        />
      </Stack>
      {data.canEdit && data.serviceId && (
        <EditServiceNotesDialog
          open={isEditDialogOpen}
          onClose={() => setIsEditDialogOpen(false)}
          onSubmit={() => {}}
          service={{ id: data.serviceId, notes: data.notes }}
        />
      )}
    </Container>
  );
};
